import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [

    {
        path: '/',
        component: () => import('../views/common/Index'),
        children: [
            // 首页
            {
                path: '/',
                name: 'home',
                component: () => import('../views/category/home/home'),
                meta: {
                    requireAuth: true,
                    crumbList: [
                        {name: '首页', path: '/', type: 'link'}
                    ]
                }
            },

            {
                path: '/company',
                name: 'company-index',
                component: () => import('../views/category/company/company-index'),
                meta: {
                    requireAuth: true,
                    crumbList: [
                        {name: '首页', path: '/', type: 'link'},
                        {name: '公司简介', path: '/company', type: 'link'},
                    ]
                },

                children: [
                    {
                        path: '/introduction',
                        name: 'introduction',
                        component: () => import('../views/category/company/introduction'),
                        meta: {
                            requireAuth: true,
                            column: ['公司简介', 'COMPANY'],
                            crumb: ['股东介绍', 'INTRODUCTION'],
                        }
                    },

                    {
                        path: '/company',
                        name: 'company',
                        component: () => import('../views/category/company/company'),
                        meta: {
                            requireAuth: true,
                            column: ['公司简介', 'COMPANY'],
                            crumb: ['公司简介', 'COMPANY'],
                        }
                    },

                    {
                        path: '/leaders',
                        name: 'leaders',
                        component: () => import('../views/category/company/leaders'),
                        meta: {
                            requireAuth: true,
                            column: ['公司简介', 'COMPANY'],
                            crumb: ['公司领导', 'COMPANY LEADERS'],
                        }
                    },
                ]
            },

            // 业务领域
            {
                path: '/business',
                name: 'business',
                component: () => import('../views/category/business/business-index'),
                meta: {
                    column: ['业务领域', 'BUSINESS'],
                    crumb: ['业务领域', 'BUSINESS'],
                },

                children: [
                    {
                        path: '/market-segments',
                        name: 'market-segments',
                        component: () => import('../views/category/business/market-segments'),
                        meta: {
                            requireAuth: true,
                            column: ['业务领域', 'BUSINESS'],
                            crumb: ['细分市场', 'MARKET SEGMENTS'],
                        }
                    },

                    {
                        path: '/aerospace',
                        name: 'aerospace',
                        component: () => import('../views/category/business/aerospace'),
                        meta: {
                            requireAuth: true,
                            column: ['业务领域', 'BUSINESS'],
                            crumb: ['航空航天', 'AEROSPACE'],
                        }
                    },

                    {
                        path: '/responsibility',
                        name: 'responsibility',
                        component: () => import('../views/category/business/responsibility'),
                        meta: {
                            requireAuth: true,
                            column: ['业务领域', 'BUSINESS'],
                            crumb: ['专业责任', 'RESPONSIBILITY'],
                        }
                    },

                    {
                        path: '/transportation',
                        name: 'transportation',
                        component: () => import('../views/category/business/transportation'),
                        meta: {
                            requireAuth: true,
                            column: ['业务领域', 'BUSINESS'],
                            crumb: ['交通运输', 'TRANSPORTATION'],
                        }
                    },

                    {
                        path: '/entertainment',
                        name: 'entertainment',
                        component: () => import('../views/category/business/entertainment'),
                        meta: {
                            requireAuth: true,
                            column: ['业务领域', 'BUSINESS'],
                            crumb: ['影视娱乐', 'ENTERTAINMENT'],
                        }
                    },

                    {
                        path: '/industrial-manufacturing',
                        name: 'industrial-manufacturing',
                        component: () => import('../views/category/business/industrial-manufacturing'),
                        meta: {
                            requireAuth: true,
                            column: ['业务领域', 'BUSINESS'],
                            crumb: ['工业制造', 'INDUSTRIAL MANUFACTURING'],
                        }
                    },

                    {
                        path: '/agricultural-insurance',
                        name: 'agricultural-insurance',
                        component: () => import('../views/category/business/agricultural-insurance'),
                        meta: {
                            requireAuth: true,
                            column: ['业务领域', 'BUSINESS'],
                            crumb: ['农业保险', 'AGRICULTURAL INSURANCE'],
                        }
                    },

                    {
                        path: '/the-belt-and-road-initiative',
                        name: 'the-belt-and-road-initiative',
                        component: () => import('../views/category/business/the-belt-and-road-initiative'),
                        meta: {
                            requireAuth: true,
                            column: ['业务领域', 'BUSINESS'],
                            crumb: ['一带一路', 'THE BELT AND ROAD INITIATIVE'],
                        }
                    },

                    {
                        path: '/educational-security',
                        name: 'educational-security',
                        component: () => import('../views/category/business/educational-security'),
                        meta: {
                            requireAuth: true,
                            column: ['业务领域', 'BUSINESS'],
                            crumb: ['教育安全', 'EDUCATIONAL SECURITY'],
                        }
                    },

                    {
                        path: '/contingency-management',
                        name: 'contingency-management',
                        component: () => import('../views/category/business/contingency-management'),
                        meta: {
                            requireAuth: true,
                            column: ['业务领域', 'BUSINESS'],
                            crumb: ['应急管理', 'CONTINGENCY MANAGEMENT'],
                        }
                    },

                    {
                        path: '/sports-events',
                        name: 'sports-events',
                        component: () => import('../views/category/business/sports-events'),
                        meta: {
                            requireAuth: true,
                            column: ['业务领域', 'BUSINESS'],
                            crumb: ['体育赛事', 'SPORTS EVENTS'],
                        }
                    },

                    {
                        path: '/reinsurance-business',
                        name: 'reinsurance-business',
                        component: () => import('../views/category/business/reinsurance-business'),
                        meta: {
                            requireAuth: true,
                            column: ['业务领域', 'BUSINESS'],
                            crumb: ['再保险业务', 'REINSURANCE BUSINESS'],
                        }
                    },

                    {
                        path: '/internet-insurance',
                        name: 'internet-insurance',
                        component: () => import('../views/category/business/internet-insurance'),
                        meta: {
                            requireAuth: true,
                            column: ['业务领域', 'BUSINESS'],
                            crumb: ['互联网保险', 'INTERNET INSURANCE'],
                        }
                    },
                ]
            },

            {
                path: '/service-objectives',
                name: 'service-index',
                component: () => import('../views/category/service/service-index'),
                meta: {
                    column: ['服务目标和内容', 'SERVICE OBJECTIVES AND CONTENTS'],
                    crumb: ['服务目标', 'SERVICE OBJECTIVES'],
                },

                children: [
                    {
                        path: '/service-objectives',
                        name: 'service-objectives',
                        component: () => import('../views/category/service/service-objectives'),
                        meta: {
                            requireAuth: true,
                            column: ['服务目标和内容', 'SERVICE OBJECTIVES AND CONTENTS'],
                            crumb: ['服务目标', 'SERVICE OBJECTIVES'],
                        }
                    },

                    {
                        path: '/service-contents',
                        name: 'service-contents',
                        component: () => import('../views/category/service/service-contents'),
                        meta: {
                            requireAuth: true,
                            column: ['服务目标和内容', 'SERVICE OBJECTIVES AND CONTENTS'],
                            crumb: ['服务内容', 'SERVICE CONTENTS'],
                        }
                    },
                ]
            },

            // 服务网络
            {
                path: '/service-network',
                name: 'service-network-index',
                component: () => import('../views/category/service-network/service-network-index'),
                meta: {
                    column: ['服务目标和内容', 'SERVICE OBJECTIVES AND CONTENTS'],
                    crumb: ['服务目标', 'SERVICE OBJECTIVES'],
                },

                children: [
                    {
                        path: '/service-network',
                        name: 'service-network',
                        component: () => import('../views/category/service-network/service-network'),
                        meta: {
                            requireAuth: true,
                            column: ['服务网络', 'SERVICE NETWORK'],
                            crumb: ['服务网络', 'SERVICE NETWORK'],
                        }
                    },
                ]
            },

            {
                path: '/information',
                name: 'information-index',
                component: () => import('../views/category/information/information-index'),
                meta: {
                    requireAuth: true,
                    column: ['信息披露', 'INFORMATION'],
                    crumb: ['信息披露', 'INFORMATION'],
                },

                children: [
                    {
                        path: '/information',
                        name: 'information',
                        component: () => import('../views/category/information/information'),
                        meta: {
                            requireAuth: true,
                            column: ['信息披露', 'INFORMATION'],
                            crumb: ['信息披露', 'INFORMATION'],
                        }
                    },
                ]
            },

            {
                path: '/hot-product',
                name: 'hot-product',
                component: () => import('../views/category/hot-product/hot-product'),
                meta: {
                    requireAuth: true,
                    column: ['热销产品', 'HOT PRODUCT'],
                    crumb: ['热销产品', 'HOT PRODUCT'],
                }
            },

            {
                path: '/announcement',
                name: 'announcement-index',
                component: () => import('../views/category/announcement/announcement-index'),
                meta: {
                    requireAuth: true,
                    column: ['公告发布', 'ANNOUNCEMENT'],
                    crumb: ['公告发布', 'ANNOUNCEMENT'],
                },

                children: [
                    {
                        path: '/announcement',
                        name: 'announcement',
                        component: () => import('../views/category/announcement/announcement'),
                        meta: {
                            requireAuth: true,
                            column: ['公告发布', 'ANNOUNCEMENT'],
                            crumb: ['公告发布', 'ANNOUNCEMENT'],
                        }
                    },
                ]
            },

            {
                path: '/company-dynamic',
                name: 'company-dynamic-index',
                component: () => import('../views/category/dynamic/company-dynamic-index'),
                meta: {
                    requireAuth: true,
                    column: ['公司动态', 'COMPANY DYNAMIC'],
                    crumb: ['公司动态', 'COMPANY DYNAMIC'],
                },

                children: [
                    {
                        path: '/notice-announcement',
                        name: 'notice-announcement',
                        component: () => import('../views/category/dynamic/notice-announcement'),
                        meta: {
                            requireAuth: true,
                            column: ['通知公告', 'NOTICE ANNOUNCEMENT'],
                            crumb: ['通知公告', 'NOTICE ANNOUNCEMENT'],
                        }
                    },
                    {
                        path: '/company-news',
                        name: 'company-news',
                        component: () => import('../views/category/dynamic/company-news'),
                        meta: {
                            requireAuth: true,
                            column: ['公司要闻', 'COMPANY NEWS'],
                            crumb: ['公司要闻', 'COMPANY NEWS'],
                        }
                    },
                    {
                        path: '/company-dynamic',
                        name: 'company-dynamic',
                        component: () => import('../views/category/dynamic/company-dynamic'),
                        meta: {
                            requireAuth: true,
                            column: ['公司动态', 'COMPANY DYNAMIC'],
                            crumb: ['公司动态', 'COMPANY DYNAMIC'],
                        }
                    },
                    {
                        path: '/policy-law',
                        name: 'policy-law',
                        component: () => import('../views/category/dynamic/policy-law'),
                        meta: {
                            requireAuth: true,
                            column: ['政策法规', 'POLICY LAW'],
                            crumb: ['政策法规', 'POLICY LAW'],
                        }
                    },
                    {
                        path: '/insurance-knowledge',
                        name: 'insurance-knowledge',
                        component: () => import('../views/category/dynamic/insurance-knowledge'),
                        meta: {
                            requireAuth: true,
                            column: ['保险知识及普及', 'INSURANCE KNOWLEDGE'],
                            crumb: ['保险知识及普及', 'INSURANCE KNOWLEDGE'],
                        }
                    }
                ]
            },

            {
                path: '/notice-announcement-details',
                name: 'notice-announcement-details',
                component: () => import('../views/category/dynamic/notice-announcement-details'),
                meta: {
                    requireAuth: true,
                    column: ['公司动态', 'COMPANY DYNAMIC'],
                    crumb: ['公司通告详情', 'NOTICE ANNOUNCEMENT DETAILS'],
                }
            },

            {
                path: '/company-news-details',
                name: 'company-news-details',
                component: () => import('../views/category/dynamic/company-news-details'),
                meta: {
                    requireAuth: true,
                    column: ['公司动态', 'COMPANY DYNAMIC'],
                    crumb: ['公司要闻', 'COMPANY DYNAMIC NEWS'],
                }
            },

            {
                path: '/company-dynamic-details',
                name: 'company-dynamic-details',
                component: () => import('../views/category/dynamic/company-dynamic-details'),
                meta: {
                    requireAuth: true,
                    column: ['公司动态', 'COMPANY DYNAMIC'],
                    crumb: ['详情页', 'COMPANY DYNAMIC DETAILS'],
                }
            },

            {
                path: '/policy-law-details',
                name: 'policy-law-details',
                component: () => import('../views/category/dynamic/policy-law-details'),
                meta: {
                    requireAuth: true,
                    column: ['公司动态', 'COMPANY DYNAMIC'],
                    crumb: ['政策法规详情页', 'POLICY LAW DETAILS'],
                }
            },

            {
                path: '/insurance-knowledge-details',
                name: 'insurance-knowledge-details',
                component: () => import('../views/category/dynamic/insurance-knowledge-details'),
                meta: {
                    requireAuth: true,
                    column: ['公司动态', 'COMPANY DYNAMIC'],
                    crumb: ['详情页', 'INSURANCE KNOWLEDGE DETAILS'],
                }
            },

            {
                path: '/contact-us',
                name: 'contact-us',
                component: () => import('../views/category/contact/contact-us'),
                meta: {
                    requireAuth: true,
                    column: ['联系我们', 'CONTACT US'],
                    crumb: ['联系我们', 'CONTACT US'],
                }
            },
        ]
    }
    // ,
    // {
    //     path: '/',
    //     name: 'maintain',
    //     component: () => import('../views/common/maintain')
    // }

];

const router = new VueRouter({
    mode: 'hash',
    routes
});

export default router
